import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { PureComponent } from 'core/components';
import { SwiperSlide, Swiper, Button } from 'core/components/Framework7';
import { CategoryItem } from 'content/components';

import { withAuth } from 'core/decorators';
import services from 'core/services';
import classes from './styles.module.css';


class CategorySwiper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {}
  }

  static get defaultProps() {
    return {
      items: [],
      navigation: true,
      swiper: {
        speed: 300,
        slidesPerView: 'auto',
        spaceBetween: 0,
        resistance: false,
        resistanceRatio: 0,
        freeModeMomentumRatio: .5,
        freeModeSticky: true,
        freeMode: true,
        preloadImages: false,
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev',
      },
    }
  }

  get initialValue() {
    return this.parseCategoryItems()
  }

  /**
   * parse items for show in category
   * @param {Array} items 
   */
  parseCategoryItems() {
    const { items } = this.props;

    return items.map(item => {
      return this.parseCategoryItem(item)
    })
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseCategoryItem(item) {
    return {
      id: item.id,
      alt: item.category ? item.category.cover ? item.category.cover.title : null : null,
      url: item.category ? item.category.cover ? services.utils.url.image(item.category.cover, 8) : null : null,
      title: item.category ? item.category.title : null,
      link: item.id,
      childrenType: item.childrenType,
    }
  }

  handleClick(e) {
    return this.props.onClick ? this.props.onClick(e) : null
  }

  renderEmpty() {
    return (
      <div className={classes.empty}>آیتمی جهت نمایش وجود ندارد</div>
    )
  }

  renderSwiperItems() {
    const items = this.initialValue;

    if (!items) return this.renderEmpty()

    return items.map(item => {
      return this.renderSwiperItem(item)
    })
  }

  renderSwiperItem(item) {
    const { navigate } = this.props;

    return (
      <SwiperSlide
        key={item.id}
        className={`${classes.swiperSlide}`}
      >
        <CategoryItem
          item={item}
          navigate={navigate}
        />
      </SwiperSlide>
    )
  }

  render() {
    const { swiper, navigation, height, loading } = this.props

    return (
      loading ?
        <Loading height={height || 38} />
        :
        <Swiper
          params={swiper}
          navigation={navigation}
          className={classes.swiper}
        >
          {this.renderSwiperItems()}
        </Swiper>
    )
  }
}

CategorySwiper.propTypes = {
  items: PropTypes.array,
  loading: PropTypes.bool,
  height: PropTypes.number,
  swiper: PropTypes.object,
};

export default connect(
  state => ({
    env: state.General.env,
  }),
  {

  }
)(withAuth(autobind(CategorySwiper)));
